import { AspectRatio } from "@mui/joy";
import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BooksCard = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        width={props.width}
        style={{
          borderRadius: "12px",
          padding: "16px",
          boxSizing: "border-box",
          height: "auto",
          marginRight: "36px",
          border: "1.6px solid rgba(0,0,0,0.08)",
          cursor: "pointer",
        }}
        onClick={() => navigate("/publications/books")}
      >
        <Grid container>
          <Grid item xs={12}>
            <AspectRatio ratio="3/4">
              <img
                src={process.env.PUBLIC_URL + "Images/BookCover/" + props.image}
                alt="Book Cover"
                style={{
                  width: "-webkit-fill-available",
                }}
              />
            </AspectRatio>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "12px" }}>
            <Typography
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
              }}
              fontWeight={600}
            >
              {props.title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
              }}
            >
              {props.author}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default BooksCard;
